var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultProfilePanda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1193,
    height: 972,
    viewBox: "0 0 1193 972",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1095.32 330.973C1148.81 255.159 1130.71 150.338 1054.9 96.8495C979.082 43.3609 874.261 61.4594 820.773 137.274L521 562.169L795.548 755.869L1095.32 330.973Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8497 330.973C43.3611 255.159 61.4596 150.338 137.274 96.8495C213.088 43.3609 317.909 61.4594 371.398 137.274L671.17 562.169L396.623 755.869L96.8497 330.973Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1109 638.032C1109 927.999 857.537 972 594.103 972C330.668 972 95 927.999 95 638.032C95 348.065 330.668 113 594.103 113C857.537 113 1109 348.065 1109 638.032Z",
    fill: "#FEFFFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M273 475C273 406.517 328.517 351 397 351C465.483 351 521 406.517 521 475V511C521 579.483 465.483 635 397 635C328.517 635 273 579.483 273 511V475Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M273 475C273 406.517 328.517 351 397 351C465.483 351 521 406.517 521 475V511C521 579.483 465.483 635 397 635C328.517 635 273 579.483 273 511V475Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M661 475C661 406.517 716.517 351 785 351C853.483 351 909 406.517 909 475V511C909 579.483 853.483 635 785 635C716.517 635 661 579.483 661 511V475Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M661 475C661 406.517 716.517 351 785 351C853.483 351 909 406.517 909 475V511C909 579.483 853.483 635 785 635C716.517 635 661 579.483 661 511V475Z",
    fill: "#C4C4C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M328 493C328 454.892 358.892 424 397 424C435.108 424 466 454.892 466 493C466 531.108 435.108 562 397 562C358.892 562 328 531.108 328 493Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M328 493C328 454.892 358.892 424 397 424C435.108 424 466 454.892 466 493C466 531.108 435.108 562 397 562C358.892 562 328 531.108 328 493Z",
    fill: "#151414"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M510 674C510 635.892 540.892 605 579 605H624C662.108 605 693 635.892 693 674C693 712.108 662.108 743 624 743H579C540.892 743 510 712.108 510 674Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M510 674C510 635.892 540.892 605 579 605H624C662.108 605 693 635.892 693 674C693 712.108 662.108 743 624 743H579C540.892 743 510 712.108 510 674Z",
    fill: "#262626"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M716 493C716 454.892 746.892 424 785 424C823.108 424 854 454.892 854 493C854 531.108 823.108 562 785 562C746.892 562 716 531.108 716 493Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M716 493C716 454.892 746.892 424 785 424C823.108 424 854 454.892 854 493C854 531.108 823.108 562 785 562C746.892 562 716 531.108 716 493Z",
    fill: "#151414"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfilePanda);
export default __webpack_public_path__ + "static/media/default-profile-panda.f475ccc7.svg";
export { ForwardRef as ReactComponent };